
function openTab(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  var modalTrigger = document.querySelector('.modal-trigger');
  var modalContainer = document.querySelector('.modal-container');
  var modalContent = document.querySelector('.modal-content');
  var modalClose = document.querySelector('.modal-close');
  
  modalTrigger.addEventListener('click', function(e) {
    e.preventDefault();
    modalContainer.style.display = 'block';
    document.body.style.overflow = 'hidden';
  });
  
  modalClose.addEventListener('click', function() {
    modalContainer.style.display = 'none';
    document.body.style.overflow = 'auto';
  });
  
  modalContainer.addEventListener('click', function(e) {
    if (e.target === modalContainer) {
      modalContainer.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });
  
  window.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      modalContainer.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });

  
  
  
  
  
  
  
  
    
  